import React, { ReactElement } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import classNames from 'classnames/bind';
import styles from 'sections/Home/components/SectionCallToAction/SectionCallToAction.module.scss';
import ImageShipOnRoute from '../../../../../public/images/pages/Home/ship-on-route.webp';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {
  return (
    <section className={cn('cta')}>
      <div className={cn('container')}>

        <div className={cn('cta__title-box')}>
          <h3 className={cn('cta__title')}>
            <span>Cutting Edge</span>
            <span>Digital Logistics Tools</span>
          </h3>
          <p className={cn('cta__title-description')}>
            With SeaRates freight forwarders are able to get access to the ultimate ecosystem of applications such
            as rate benchmarking, cargo tracking, route optimization, schedules, paperwork and more! All of this is
            available with SaaS access, API and white-label web integrations.
          </p>
          <div className={cn('cta__buttons')}>
            {/* New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <Link className={cn('cta__button-register')} href="/membership">
              Register
            </Link> */}
          </div>
        </div>

        <div className={cn('cta__image-box')}>
          <Image
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
            }}
            className={cn('cta__image')}
            src={ImageShipOnRoute}
            alt="terminals"
          />
        </div>

      </div>
    </section>
  );
};

export default SectionFeatures;